//@flow

import React, { useState, useEffect } from "react";
import camelcase from "camelcase";

import { View } from "@components";
import { Tab, type TabProps } from "./tab";

type Props = $Exact<{
  title: React$Element<typeof View>[] | string,
  customTitle?: string,
  children: React$Element<typeof Tab>[],
  activeTab?: number,
  className: string,
  onTabChange?: Function,
  noHash?: boolean,
}>;

export function TabBar(props: Props) {
  const [activeTab, setActiveTab] = useState();
  const noHash = !!props?.noHash || false;
  const tabs: React$Element<typeof Tab>[] = props.children.map(tab => {
    return {
      ...tab,
      props: {
        id: tab.props.id || camelcase(tab.props.title),
        ...tab.props,
      },
    };
  });

  const hash = window.location.hash.toLocaleLowerCase();

  useEffect(() => {
    let active = props.activeTab || 0;
    if (noHash === false && hash) {
      active = tabs.findIndex(tab => {
        const tabId = (tab.props.id || "").toLocaleLowerCase();
        return `#${tabId.replace(" ", "%20")}` == hash;
      });
      if (active < 0) {
        active = 0;
      }
    }
    handleSetActiveTab(active);
  }, []);

  function handleSetActiveTab(tabIndex: number) {
    setActiveTab(_ => tabIndex);
    const tabId = tabs[tabIndex].props.id;

    if (noHash === false) {
      window.location.hash = (tabId || "").toLocaleLowerCase();
    }
  }

  function handleTabClick(idx) {
    return function() {
      handleSetActiveTab(idx);
      props.onTabChange && props.onTabChange(idx);
    };
  }

  return (
    <div className={`d-flex flex-column tab-bar ${props.className || ""}`}>
      {props.title}
      {/* Tabs */}
      <View direction="row" gap={2} className="tabs">
        {React.Children.toArray(tabs)
          .filter(tab => !tab.props.isHidden)
          .map((tab, index) => {
            if (tab.props.hidden && tab.props.hidden === true) {
              return null;
            }

            return React.cloneElement(tab, {
              onClick: handleTabClick(index),
              isActive: !!(index === activeTab),
            });
          })}
      </View>
      {/* Content */}
      <div className="tabs-content">{tabs[activeTab] && tabs[activeTab].props.children}</div>
    </div>
  );
}

TabBar.Tab = Tab;
